import React from 'react';

export default function VideoLogo() {
  return <img src="/logo.png" alt="Lingua Fonica logo" />;
}
